import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 24 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.8, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export const Label = ({ children, className = "", tone = "brand" }) => (
  <span className={`label-mono inline-flex items-center gap-3 ${tone === "dark" ? "text-brand-soft" : "text-brand"} ${className}`}>
    <span className="h-px w-8 bg-current" aria-hidden />
    {children}
  </span>
);

export const SectionHead = ({ label, title, text, tone = "brand", className = "" }) => (
  <Reveal className={`max-w-3xl ${className}`}>
    <Label tone={tone}>{label}</Label>
    <h2 className="mt-5 font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight sm:text-5xl lg:text-6xl">{title}</h2>
    {text && <p className={`mt-6 max-w-2xl text-base leading-relaxed sm:text-lg ${tone === "dark" ? "text-canvas/75" : "text-steel"}`}>{text}</p>}
  </Reveal>
);

export const PageHeader = ({ label, title, text, testid }) => (
  <section className="relative cad-grid border-b border-canvas-line pt-36 pb-16 sm:pt-44 sm:pb-20" data-testid={testid}>
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Label>{label}</Label>
      <h1 className="mt-6 max-w-5xl font-display text-5xl font-extrabold uppercase leading-[0.9] tracking-tight sm:text-6xl lg:text-7xl">{title}</h1>
      {text && <p className="mt-8 max-w-2xl text-base leading-relaxed text-steel sm:text-lg">{text}</p>}
    </div>
  </section>
);
